import { Button, Skeleton, Stack } from '@mui/material';
import { useMemo } from 'react';
import { randomString } from 'remeda';
import { normalizeSuggestedQuestions } from './sidekick-utils';
import {
  suggestedQuestionButtonSx,
  suggestedQuestionsContainerSx,
  suggestedQuestionSkeletonSx,
} from './suggested-questions.styles';

const SKELETON_WIDTHS = ['80%', '92%', '60%'];

interface SuggestedQuestionsProps {
  questions: string[];
  loading: boolean;
  onSelect: (question: string) => void;
  disabled: boolean;
}

export const SuggestedQuestions = ({
  questions,
  loading,
  onSelect,
  disabled,
}: SuggestedQuestionsProps) => {
  const normalizedQuestions = useMemo(
    () => normalizeSuggestedQuestions(questions),
    [questions],
  );

  if (!loading && normalizedQuestions.length === 0) return null;

  return (
    <Stack sx={suggestedQuestionsContainerSx}>
      {loading
        ? SKELETON_WIDTHS.map((width, index) => (
            <Skeleton
              key={randomString(index)}
              variant="rounded"
              height="1.75rem"
              width={width}
              sx={suggestedQuestionSkeletonSx}
            />
          ))
        : normalizedQuestions.map((question) => (
            <Button
              key={question}
              onClick={() => onSelect(question)}
              disabled={disabled}
              sx={suggestedQuestionButtonSx}
            >
              {question}
            </Button>
          ))}
    </Stack>
  );
};
